import type { TypeWindow } from 'geoview-core/core/types/global-types';
import type { Extent } from 'geoview-core/api/types/map-schema-types';
import { logger } from 'geoview-core/core/utils/logger';
import { useMapStoreActions } from 'geoview-core/core/stores/store-interface-and-intial-values/map-state';
import { getSxClasses } from './area-of-interest-style';

interface AoiPanelProps {
  mapId: string;
  config: TypeAoiProps;
}

interface AoiItem {
  aoiTitle: string;
  imageUrl: string;
  extent: Extent;
}

type AoiListItems = AoiItem[];

export type TypeAoiProps = {
  isOpen: boolean;
  aoiList: AoiListItems;
  version: string;
};

export function AoiPanel(props: AoiPanelProps): JSX.Element {
  const { mapId, config } = props;
  const { aoiList } = config;

  const { cgpv } = window as TypeWindow;
  const { api, ui } = cgpv;

  const myMap = api.getMapViewer(mapId);
  const { Card, Box } = ui.elements;

  const theme = ui.useTheme();
  const sxClasses = getSxClasses(theme);

  const { highlightBBox } = useMapStoreActions();

  return (
    <Box sx={sxClasses.aoiCard}>
      {aoiList.map((aoiItem: AoiItem, index) => {
        return (
          <Card
            tabIndex={0}
            className="aoiCardThumbnail"
            onClick={() => {
              myMap
                .zoomToLonLatExtentOrCoordinate(aoiItem.extent, { maxZoom: 14 })
                .then(() => {
                  highlightBBox(myMap.convertExtentLonLatToMapProj(aoiItem.extent), false);
                })
                .catch((error: unknown) => {
                  // Log
                  logger.logPromiseFailed('in zoomToLonLatExtentOrCoordinate', error);
                });
            }}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            title={aoiItem.aoiTitle}
            contentCard={
              // eslint-disable-next-line react/jsx-no-useless-fragment
              <>
                {typeof aoiItem.imageUrl === 'string' && (
                  // eslint-disable-next-line react/no-array-index-key
                  <Box component="img" key={index} src={aoiItem.imageUrl} alt="" className="aoiCardThumbnail" />
                )}
              </>
            }
          />
        );
      })}
    </Box>
  );
}
